module.exports = __webpack_public_path__ + "img/logo-mediaform.9e9a1a2.svg";